/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';

import { RideIcProtectionLight } from '@rimac-seguros/ride-system-components';

import { SelectionDetail } from '../../../../components/molecules';
import {
  Button, Input, InputBirthdate, InputGroup, Radio,
} from '../../../../components/atoms';
import { useAppContext } from '../../../../AppProvider';
import {
  capitalize,
  getErrorPage,
  validateCE,
  validateDNI,
  verifyEmail,
  verifyLetters,
  generatePayloadValidar,
  analizeRespValidar,
  calculateAge,
  getTextFromAttempts,
} from '../../../../utils/helpers';
import {
  abortRequest,
  addThirdInQuote,
  calculateDiscount,
  createQuote,
  createQuoteFlex,
  getPersonData,
  registerLead,
  selectPlan,
  validatePersonCV,
  validatePreExisting,
  validateSinister,
} from '../../../../services/clientServices';
import { getTagLog } from '../../../../utils/analytics';
import {
  ageValidate, decryptAES, getBeginningValidity, getCodeSecurity, getEndValidity,
} from '../../../../utils/functions';
import ModalPortal from '../../../../components/molecules/rbrModal/ModalPortal';
import { requestCalculatePlan, requestSelectPlan, requestThird } from '../../../../services/requests';
import Notification from '../../../../assets/step-coverages/icon_notification.svg';
import { formatRequestQuote, getRequestQuoteFlex } from '../../../../utils/requests-cotizacions';
import { decryptCredentials } from '../../../../utils/cifrate';
import { AUDITORY_MODEL } from '../../../../models/step-data';
import RegisterAuditory from '../../../../auditory/component/RegisterAuditory';
import { useHistory } from '../../../../hooks/useHistory';

const FormFamiliar = () => {
  const { navigate } = useHistory();
  const [firstName, setFirstName] = useState('');
  const [lastName1, setLastName1] = useState('');
  const [lastName2, setLastName2] = useState('');
  const [documentType, setDocumentType] = useState('dni');
  const [documentNumber, setDocumentNumber] = useState('');
  const [selectedGender, setSelectGender] = useState('');
  const documentMaxLength = documentType === 'dni' ? '8' : '12';
  const documentTypeNumber = documentType === 'dni' ? '2' : '4';
  const [docError, setDocError] = useState('');
  const [disabledInputs, setDisabledInputs] = useState(false);
  const [loading, setLoading] = useState(false);

  function validateInput() {
    let isValid = true;
    setDocError('');
    if (documentType === 'dni' && !validateDNI(documentNumber)) {
      setDocError('*Es necesario que ingreses tu Nro. de documento');
      isValid = false;
    } else if (documentType === 'ce' && !validateCE(documentNumber)) {
      setDocError('*Es necesario que ingreses tu Nro. de documento');
      isValid = false;
    }
    isValid = false;
    return setDisabledInputs(isValid);
  }
  useEffect(() => {
    validateInput();
    return () => validateInput();
  }, [documentNumber, firstName, lastName1, lastName2]);

  function getClient() {
    if (parseInt(documentMaxLength, 10) === documentNumber.length) {
      setDisabledInputs(true);
      setLoading(true);
      const request = {
        tipoDocumento: documentTypeNumber,
        numeroDocumento: documentNumber,
      };
      getPersonData(request)
        .then((res) => {
          const data = JSON.parse(decryptAES(res.payload.data, getCodeSecurity()));
          // dispatch({ type: 'SAVE_CLIENT', payload: data });
          const { apellidoMaterno, apellidoPaterno, nombres } = data;
          setLastName1(apellidoPaterno);
          setLastName2(apellidoMaterno);
          setFirstName(nombres);
          setLoading(false);
          setDisabledInputs(false);
        })
        .catch((error) => {
          setDisabledInputs(false);
          const errorResponse = error.response;
          const clientNotFound = errorResponse.data.error.code;
          if (clientNotFound === '001-05') {
            setLoading(false);
          }
          navigate(getErrorPage(error, 'OBTENER_PERSONA'));
        });
    }
  }
  function handleValidate() {}
  return (
    <div>
      <p>Datos de tus familiares</p>
      <div className="item-new_gender">Género</div>
      <div className="col title w100 gender">
        <h4 className="title__subtitle">Género</h4>
      </div>
      <div className="radiobutton">
        <input type="radio" name="gender" id="man" value="Masculino" onChange={(e) => setSelectGender(e)} checked={selectedGender} />
        <label htmlFor="man">Masculino</label>
      </div>
      <div className="radiobutton">
        <input type="radio" name="gender" id="woman" value="Femenino" onChange={(e) => setSelectGender(e)} checked={selectedGender} />
        <label htmlFor="woman">Femenino</label>
      </div>
      <div className="mb-16 wrapper-field">
        <InputGroup
          type="text"
          maxLength={documentMaxLength}
          options={[
            {
              value: 'dni',
              label: 'DNI',
            },
            {
              value: 'ce',
              label: 'C.E.',
            },
          ]}
          defaultValue={documentType}
          inputValue={documentNumber}
          onInputChange={(value) => setDocumentNumber(value)}
          onSelectChange={(value) => setDocumentType(value)}
          label="N° de documento"
          error={docError}
          onBlur={() => getClient()}
          disabled={disabledInputs}
        />
      </div>
      <div className="mt-16 wrapper-field">
        <Input
          label="Nombres"
          type="text"
          value={firstName}
          onChange={(value) => {
            setFirstName(value);
          }}
        />
      </div>
      <div className="two-col">
        <div className="mt-16 wrapper-field last-name-1">
          <Input
            label="Apellido Paterno"
            type="text"
            value={lastName1}
            onChange={(value) => {
              setLastName1(value);
            }}
          />
        </div>
        <div className="mt-16 wrapper-field last-name-2">
          <Input
            label="Apellido Materno"
            type="text"
            value={lastName2}
            onChange={(value) => {
              setLastName2(value);
            }}
          />
        </div>
      </div>
      <div className="mt-16 wrapper-field">
        <Button specialClass="button btn-normal" loading={loading} type="" label="guardar datos" disabled={disabledInputs} onClick={() => handleValidate()} />
      </div>
    </div>
  );
};

const StepData = () => {
  const [mail, setMail] = useState('');
  const [mailError, setMailError] = useState('');
  const [form, setForm] = useState({
    firstName: '',
    lastName1: '',
    lastName2: '',
  });
  const [formError, setFormError] = useState({
    firstName: '',
    lastName1: '',
    lastName2: '',
  });
  const [validForm, setValidForm] = useState({
    firstName: false,
    lastName1: false,
    lastName2: false,
  });
  const {
    state: {
      planSelected, client, insuredList, leadData, address,
    },
    dispatch,
  } = useAppContext();
  const fechaNacimiento = moment(client.fechaNacimiento, 'YYYY-MM-DD').toDate();
  const fDate = moment(fechaNacimiento).format('DD/MM/YYYY');
  const coverageSelected = { title: { head: 'DETALLE DE SELECCIÓN', value: planSelected?.name }, price: planSelected.price, client };
  const [updateListInsured, setUpdateListInsured] = useState(insuredList);
  const [loading, setLoading] = useState(false);
  const [selectedGender, setSelectGender] = useState(client.sexo === 'F' ? 'Femenino' : client.sexo === 'M' ? 'Masculino' : '');
  const { navigate } = useHistory();
  const { indExisteTercero } = client;
  const { nombres, apellidoPaterno, apellidoMaterno } = client;
  const nameResult = indExisteTercero
    ? capitalize(`${nombres.split(' ')[0]} ${apellidoPaterno} ${apellidoMaterno}`)
    : nombres + apellidoPaterno + apellidoMaterno;
  const dateResult = fDate;
  const [validateModal, setValidateModal] = useState(false);
  const [valAttemps, setValAttemps] = useState(0);

  const [errors, setErrors] = useState({
    nombres: '',
    apepat: '',
    apemat: '',
    fecnac: '',
    sexo: '',
  });

  const [birthdate, setBirthdate] = useState({
    day: '',
    month: '',
    year: '',
  });

  const [showErrorBirthdate, setShowErrorBirthdate] = useState(false);
  const [errorBirthdate, setErrorBirthdate] = useState(false);
  const [listInsured] = useState([
    {
      age: calculateAge(client.fechaNacimiento),
      relationship: 0,
    },
  ]);

  const [showModal, setShowModal] = useState(false);
  // const [discountPlan, setDiscountPlan] = useState({});
  const [correctedAgeInput, setcorrectedAgeInput] = useState('');

  const validateSinisterController = useRef({ signal: null, abort: abortRequest });
  const validatePreExistingController = useRef({ signal: null, abort: abortRequest });
  const registerLeadController = useRef({ signal: null, abort: abortRequest });
  const validatePersonCVController = useRef({ signal: null, abort: abortRequest });

  useEffect(() => () => {
    validateSinisterController.current?.abort(validateSinisterController.current?.signal);
    validatePreExistingController.current?.abort(validatePreExistingController.current?.signal);
    registerLeadController.current?.abort(registerLeadController.current?.signal);
    validatePersonCVController.current?.abort(validatePersonCVController.current?.signal);
  }, []);

  const updateJustClient = (relation) => {
    const result = insuredList.map((insured) => {
      const copyInsured = insured;
      if (insured.relationship === relation) {
        copyInsured.name = form.firstName || capitalize(client.nombres.split(' ')[0]);
        copyInsured.lastname1 = form.lastName1 || client.apellidoPaterno;
        copyInsured.lastname2 = form.lastName2 || client.apellidoMaterno;
        copyInsured.email = mail;
        copyInsured.typeDoc = client.tipoDocumento;
        copyInsured.numDoc = client.numeroDocumento;
        copyInsured.born = client.fechaNacimiento;
        copyInsured.gender = client.sexo ? client.sexo : selectedGender === 'Masculino' ? 'M' : 'F';
        copyInsured.phone = client.telefono;
        copyInsured.civilState = client.estadoCivil;
      }
      return copyInsured;
    });
    return setUpdateListInsured(result);
  };

  const getRequestQuote = () => ({
    tipoFlujo: decryptCredentials(process.env.REACT_APP_TIPO_FLUJO),
    ideCanal: parseInt(decryptCredentials(process.env.REACT_APP_ID_CANAL), 10),
    ideVendedor: parseInt(decryptCredentials(process.env.REACT_APP_ID_VENDEDOR), 10),
    ideGrupoProd: parseInt(decryptCredentials(process.env.REACT_APP_ID_GRUPO_PRODUCTO), 10),
    usuEmision: decryptCredentials(process.env.REACT_APP_USUARIO_EMISION),
    idpMoneda: decryptCredentials(process.env.REACT_APP_CODIGO_SOLES),
    fecIniVig: getBeginningValidity(),
    fecFinVig: getEndValidity(),
    periodo: parseInt(decryptCredentials(process.env.REACT_APP_PERIODO), 10),
    numIdIntermediario: parseInt(decryptCredentials(process.env.REACT_APP_NUM_ID_INTERMEDIARIO), 10),
    usuarioEmisor: decryptCredentials(process.env.REACT_APP_USUARIO_EMISOR),
    canal: decryptCredentials(process.env.REACT_APP_CANAL),
    asegurados: formatRequestQuote(listInsured),
    indicadorCotizacion: decryptCredentials(process.env.REACT_APP_INDICADOR_COTIZACION),
    indConsentimiento: decryptCredentials(process.env.REACT_APP_INDICADOR_CONSENTIMIENTO),
    financiamiento: {
      idePlanFinanciamiento: parseInt(decryptCredentials(process.env.REACT_APP_ID_PLAN_FINANCIAMIENTO_SOLES), 10),
      numCuota: 12,
      fecIni: getBeginningValidity(),
      ideTipoTarjetaRefExt: '',
    },
    cotizacionRapida: 0,
  });

  const recalculatePlan = () => {
    setShowModal(true);
    const paramsRequestQuoteFlex = {
      planSelected,
      leadData,
      client,
      coverageAditional: planSelected.completeCoverages,
      birthdate,
      mail,
    };
    Promise.all([createQuoteFlex(getRequestQuoteFlex(paramsRequestQuoteFlex)), createQuote(getRequestQuote())])
      .then(([, respQuote]) => {
        dispatch({ type: 'SAVE_ID_QUOTE', payload: respQuote.ideCotizacion });
        const quotePlans = respQuote.rptaCalculoPrima;
        const quotePlanFilter = quotePlans.filter((e) => e.nroPlan === 190028);
        const reqPlanSelected = {
          idQuote: respQuote.ideCotizacion,
          planFlexSelected: quotePlanFilter[0],
        };
        selectPlan(requestSelectPlan(reqPlanSelected)).then(() => {
          const reqThird = {
            idQuote: respQuote.ideCotizacion,
            client,
            address,
          };
          addThirdInQuote(requestThird(reqThird)).then(() => {
            calculateDiscount(requestCalculatePlan(respQuote.ideCotizacion)).then((respDiscount) => {
              const planWithDiscount = respDiscount[0]?.rptaCalculoPrima;
              const discountPlanFilter = planWithDiscount.filter((e) => e.nroPlan === 190028);
              if (discountPlanFilter[0]) {
                // setDiscountPlan(discountPlanFilter[0]);
                setShowModal(false);
                dispatch({ type: 'SAVE_DISCOUNT', payload: discountPlanFilter[0] });
                dispatch({ type: 'SAVE_PLAN_FLEX_SELECTED', payload: discountPlanFilter[0] });
              } else {
                navigate('/comprar/seguro-salud-flexible/error');
              }
            });
          });
        });
      })
      .catch((error) => {
        navigate(getErrorPage(error, 'CREAR_COTIZACION'));
      });
  };

  const nextStep = async () => {
    updateJustClient(0);
    dispatch({ type: 'SAVE_INSURED_LIST', payload: updateListInsured });
    // save mail
    client.correo = mail;
    client.fechaNacimiento = errorBirthdate ? `${birthdate.year}-${birthdate.month}-${birthdate.day}` : client.fechaNacimiento;
    setcorrectedAgeInput(calculateAge(`${birthdate.year}-${birthdate.month}-${birthdate.day}`));
    if (!client.indExisteTercero) {
      client.nombres = form.firstName;
      client.apellidoPaterno = form.lastName1;
      client.apellidoMaterno = form.lastName2;
      client.sexo = selectedGender === 'Masculino' ? 'M' : 'F';
    }
    dispatch({ type: 'SAVE_CLIENT', payload: client });
    setLoading(true);
    const requestLead = leadData;
    requestLead.finalizado = 3;
    const request = {
      afiliados: [{ tipDocumento: client.tipoDocumento.toString(), numDocumento: client.numeroDocumento }],
    };
    const requestValidar = generatePayloadValidar(client);
    validatePersonCV(requestValidar, (signal) => {
      validatePersonCVController.current.signal = signal;
    })
      .then((resp) => {
        const data = JSON.parse(decryptAES(resp, getCodeSecurity()));
        const totalAttempts = valAttemps + 1;
        if (!analizeRespValidar(data, client)) {
          getTagLog(getTextFromAttempts(totalAttempts), 'trackLog');

          if (totalAttempts === 3) {
            getTagLog(getTextFromAttempts(3), 'trackLog');
            return navigate('/comprar/seguro-salud-flexible/asegurados/gracias');
          }
          setLoading(false);

          setValAttemps(totalAttempts);
          const validateFields = data?.resultinterpretacion?.camposcorregidos;
          const errorsValidate = {};

          validateFields?.forEach((field) => {
            if (!errorsValidate[field]) {
              if (field === 'fecnac') setErrorBirthdate(true);
              errorsValidate[field] = '*Error en campo';
            }
          });
          setErrors(errorsValidate);
          setValidateModal(true);
        } else {
          const originalAge = parseInt(calculateAge(client.fechaNacimiento), 10);
          if (correctedAgeInput !== '' && parseInt(correctedAgeInput, 10) !== originalAge) recalculatePlan();
          registerLead(requestLead, (signal) => {
            registerLeadController.current.signal = signal;
          })
            .then(() => {
              dispatch({ type: 'ADD_LEAD_DATA', payload: requestLead });
              let valorPreexistencia;
              let valorSiniestro;
              validatePreExisting(request, (signal) => {
                validatePreExistingController.current.signal = signal;
              })
                .then((respPreexistencia) => {
                  valorPreexistencia = respPreexistencia.payload.payload.result;
                  validateSinister(request, (signal) => {
                    validateSinisterController.current.signal = signal;
                  })
                    .then((respSiniestro) => {
                      valorSiniestro = respSiniestro.payload.payload.result;
                      // eslint-disable-next-line no-plusplus
                      for (let i = 0; i < valorPreexistencia.length; i++) {
                        if (valorPreexistencia[i].indPreexistenciasEps === 1 || valorSiniestro[i].indSiniestro === 1) {
                          return navigate('/comprar/seguro-salud-flexible/asegurados/gracias');
                        }
                      }
                      navigate('/comprar/seguro-salud-flexible/declaracion-salud');
                    })
                    .catch((error) => navigate(getErrorPage(error, 'VALIDAR_SINIESTROS')));
                })
                .catch((error) => navigate(getErrorPage(error, 'EVALUAR_PREEXISTENCIAS')));
            })
            .catch((error) => navigate(getErrorPage(error, 'AGREGAR_LEADS')));
        }
      })
      .catch((err) => {
        navigate(getErrorPage(err, 'VALIDAR_TERCERO'));
      });
  };

  useEffect(() => {
    // getTagVirtual('sol:comprar:seguro-salud-flexible:asegurados');
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 2);
  }, []);

  const validateDisabledBtn = () => {
    if (indExisteTercero) {
      return !verifyEmail(mail);
    }
    if (client.tipoDocumento === 4 && form.lastName2 === '' && validForm.firstName && validForm.lastName1 && verifyEmail(mail)) {
      return false;
    }
    return !validateFormInputs();
  };

  const validateFormInputs = () => verifyEmail(mail) && validForm.firstName && validForm.lastName1 && validForm.lastName2;

  const handleChangeInput = (input, value) => {
    setForm({ ...form, [input]: value });
    setFormError({ ...formError, [input]: '' });
    setValidForm({ ...validForm, [input]: verifyLetters(value) && value.length > 0 });
  };

  const handleBlurInput = (input, value) => {
    if (!verifyLetters(value)) {
      if (value === '') {
        if (client.tipoDocumento === 4 && input !== 'lastName2' && value === '') {
          setFormError({
            ...formError,
            [input]: '*Campo requerido',
          });
        } else if (client.tipoDocumento === 2) {
          setFormError({
            ...formError,
            [input]: '*Campo requerido',
          });
        }
      } else {
        setFormError({
          ...formError,
          [input]: '*Formato de texto incorrecto',
        });
      }
    }
  };

  const handleChangeBirthDay = (value) => {
    setBirthdate(value);
    const { showError } = ageValidate(value);
    setShowErrorBirthdate(showError);
    setErrors((prevErrors) => ({
      ...prevErrors,
      fecnac: '',
    }));
  };

  const toggleModalValidate = () => {
    setValidateModal(!validateModal);
  };

  const selectGender = (value) => {
    setSelectGender(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      sexo: '',
    }));
  };

  return (
    <>
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <div className="step-container content-data">
        <div className="container">
          <div className="step-container-container">
            <div className="content-full">
              <div className="content-full__left step-data-content-left">
                <div className="step-container-content">
                  <h3 className="step-container-content_title">Completa tus datos</h3>
                  <div className="step-container-content_desc">
                    {!indExisteTercero ? 'Ingresa tus datos personales para continuar con tu compra.' : 'Ingresa tu correo para continuar con la compra.'}
                  </div>
                  <div className="step-container-content_data">
                    <h4 className="step-container-content_data-title">Datos del titular</h4>
                    <div className="step-container-content_data-detail">
                      <div className="item-flex">
                        {indExisteTercero ? <div className="item-flex_name">{`${nameResult}`}</div> : ''}
                        <div className="item-flex_data">
                          {`${Number(client.tipoDocumento) === 4 ? 'CE:' : 'DNI:'}`}
                          <span>{` ${client.numeroDocumento}`}</span>
                        </div>
                        {!errorBirthdate && (
                          <div className="item-flex_data">
                            Fecha de nacimiento:
                            <span>{` ${dateResult}`}</span>
                          </div>
                        )}
                      </div>
                      <div>
                        <RideIcProtectionLight size="large" />
                      </div>
                    </div>

                    {!indExisteTercero ? (
                      <>
                        <div className="item-new_gender">Género</div>
                        <Radio value="Masculino" label="Masculino" onClick={(value) => selectGender(value)} checked={selectedGender} specialClass="mg-16" />
                        <Radio value="Femenino" label="Femenino" onClick={(value) => selectGender(value)} checked={selectedGender} specialClass="mg-16" />
                        {errors.sexo && (
                          <div className="wrapper-field">
                            <span>{errors.sexo}</span>
                          </div>
                        )}
                        <div className="mt-16 wrapper-field">
                          <Input
                            label="Nombres"
                            maxLength="30"
                            type="text"
                            value={form.firstName}
                            onChange={(value) => {
                              handleChangeInput('firstName', value);
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                nombres: '',
                              }));
                            }}
                            error={errors.nombres || formError.firstName}
                            errorText={errors.nombres || formError.firstName}
                            onBlur={() => handleBlurInput('firstName', form.firstName)}
                          />
                        </div>
                        <div className="two-col">
                          <div className="mt-16 wrapper-field last-name-1">
                            <Input
                              label="Apellido Paterno"
                              maxLength="20"
                              type="text"
                              value={form.lastName1}
                              onChange={(value) => {
                                handleChangeInput('lastName1', value);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  apepat: '',
                                }));
                              }}
                              error={formError.lastName1 || errors.apepat}
                              errorText={formError.lastName1 || errors.apepat}
                              onBlur={() => handleBlurInput('lastName1', form.lastName1)}
                            />
                          </div>
                          <div className="mt-16 wrapper-field last-name-2">
                            <Input
                              label="Apellido Materno"
                              maxLength="20"
                              type="text"
                              value={form.lastName2}
                              onChange={(value) => {
                                handleChangeInput('lastName2', value);
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  apemat: '',
                                }));
                              }}
                              error={formError.lastName2 || errors.apemat}
                              errorText={formError.lastName2 || errors.apemat}
                              onBlur={() => handleBlurInput('lastName2', form.lastName2)}
                            />
                          </div>
                        </div>
                        {errorBirthdate && (
                          <div className="mt-16 wrapper-field">
                            <InputBirthdate
                              value={birthdate}
                              setValue={(value) => handleChangeBirthDay(value)}
                              errorText={errors.fecnac}
                              showError={errors.fecnac || showErrorBirthdate}
                            />
                          </div>
                        )}
                      </>
                    ) : (
                      ''
                    )}

                    <div>
                      <div className="mt-16 wrapper-field pb-sp">
                        <Input
                          label="Correo electrónico"
                          type="text"
                          maxLength="50"
                          value={mail}
                          onChange={(value) => {
                            setMail(value);
                            setMailError(!verifyEmail(value) ? '*Ingresa un correo electrónico válido.' : '');
                          }}
                          error={mailError}
                          errorText={mailError}
                        />
                      </div>
                    </div>
                    {insuredList.length > 1
                      && insuredList.map((insured) => insured.relationship !== 0 && <FormFamiliar />)}
                  </div>
                </div>
              </div>
              {validateModal && (
                <ModalPortal
                  isOpen={validateModal}
                  srcIcon={Notification}
                  title="MENSAJE DE VALIDACION"
                  description="Los datos ingresados no coinciden con nuestros registros"
                  callbackClose={toggleModalValidate}
                />
              )}
              <div className="content-full__right">
                <SelectionDetail
                  coverageSelected={coverageSelected}
                  handleClick={() => nextStep()}
                  loading={loading}
                  insuredLength={insuredList.length}
                  disabledButton={validateDisabledBtn()}
                  planSelected={planSelected}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalPortal
        isOpen={showModal}
        srcIcon={Notification}
        title="¡Danos un momento!"
        description="Estamos actualizando el monto de tu plan"
        typeButton="loading"
        showIconClose={false}
      />
    </>
  );
};

export default StepData;
